'use client';

import { c as _c } from "react/compiler-runtime";
import { Tabs } from '@petsmart-ui/sparky';
import { dataLayerPush, getBaseUrlJoined } from '@libs/analytics';
import { MarketingSection } from './MarketingSection';
import { RecursiveMenu } from './RecursiveMenu';
import type { CategoryTypes, TabbedMenuProps } from './types';
import { getCategoryPath, trackingData } from './utils';
export function TabbedMenu(t0) {
  const $ = _c(10);
  const {
    parentCategories,
    path,
    parentCategory
  } = t0;
  let t1;
  if ($[0] !== parentCategories || $[1] !== parentCategory) {
    t1 = (_e, i) => {
      dataLayerPush(trackingData({
        selection: `${parentCategory} | ${parentCategories[i].displayText}`,
        link_url: getBaseUrlJoined(parentCategories[i].link)
      }));
    };
    $[0] = parentCategories;
    $[1] = parentCategory;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== parentCategories || $[4] !== parentCategory || $[5] !== path) {
    t2 = parentCategories?.filter(_temp).map(t3 => {
      const {
        sysId,
        displayText,
        categories,
        specialType,
        rightMenuCard,
        wrapListItems,
        link
      } = t3;
      const newPath = getCategoryPath(path, displayText);
      return <Tabs.Panel key={sysId} title={displayText} href={link}><ul className="submenu-container__list" id={displayText?.toLowerCase().trim().split(" ").join("-")}><RecursiveMenu path={newPath} parentCategory={`${parentCategory} | ${displayText}`} parentCategories={categories as CategoryTypes[]} wrapListItems={Boolean(wrapListItems)} /></ul><MarketingSection rightMenuCard={rightMenuCard} childCategories={categories as CategoryTypes[]} specialType={specialType} path={newPath} /></Tabs.Panel>;
    });
    $[3] = parentCategories;
    $[4] = parentCategory;
    $[5] = path;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div><Tabs className="submenu-container__list" changeTabOnHoverAndFocus={true} onTabClick={t1}>{t2}</Tabs></div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(category, index, self) {
  return index === self.findIndex(c => c.sysId === category.sysId);
}